<script lang="ts">
  import PhoneInput from "@shared/svelte/Components/PhoneInput.svelte";
  import type { SalesRep } from "@shared/types/SalesRep";
  import type { Distributor } from "@shared/types/Distributor";
  import { isValidDomain } from "@shared/services/sales_rep_domain_validation";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let salesRep: SalesRep;
  export let emailIsValid: boolean;
  export let distributor: Distributor;

  const distributorDomainValidator = (value: string) => {
    let domain = value.split("@")[1];

    return {
      valid: isValidDomain(domain, distributor.id) || value == "",
      name: "invalidDomain",
    };
  };

  const validateDomain = e => {
    emailIsValid = distributorDomainValidator(e.target.value).valid;
  };

</script>

<div
  class="grid-container background-grayLight add-rep-manually margin-top--small padding-top--smaller"
>
  <div class="grid-row padding-top--smallest padding-bottom--smaller">
    <div class="grid-col c12-12 c6-12--md padding-top--smaller">
      <div class="label input__label--left padding-bottom--smallest">First & Last Name*</div>
      <div class="input-wrapper margin-bottom--smallest full-width">
        <input class="input name-input" bind:value={salesRep.name} placeholder="Name" name="name" />
      </div>
    </div>
    <div class="grid-col c12-12 c6-12--md padding-top--smaller">
      <div class="label input__label--left padding-bottom--smallest">Phone Number*</div>
      <div class="input-wrapper margin-bottom--smallest full-width">
        <PhoneInput
          bind:value={salesRep.contact_phone}
          placeholder="Phone"
          id="phone"
          extraClasses="phone-input input"
        />
      </div>
    </div>
    <div class="grid-col c12-12 c12-12--md padding-top--smaller">
      <div class="label input__label--left padding-bottom--smallest">Email*</div>
      <div class="input-wrapper margin-bottom--small full-width">
        <input
          class="input email-input full-width"
          type="email"
          placeholder="Sales Rep Email"
          name="contact_email"
          on:change={validateDomain}
          on:keyup={validateDomain}
          bind:value={salesRep.contact_email}
        />
      </div>
      {#if !emailIsValid}
        <div class="fizz-flex-row-4 fizz-align-content-start">
          <Icon type="Error" height={20} width={16} />
          <p class="fizz-text-medium fizz-text-negative">
            This email belongs to a different distributor. Select a different distributor or enter a
            new email.
          </p>
        </div>
      {/if}
    </div>
  </div>
</div>
